export const INITIAL_STATE = "INITIAL_STATE";
export const CHANGE_PHONE_NUMBER = "CHANGE_PHONE_NUMBER";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_SHOW_PASSWORD = "CHANGE_SHOW_PASSWORD";
export const RESET_ERROR = "RESET_ERROR";
export const ERROR_SUBMIT = "ERROR_SUBMIT";
export const UPDATE_ERROR_PHONE_NUMBER = "UPDATE_ERROR_PHONE_NUMBER";
export const UPDATE_ERROR_PASSWORD = "UPDATE_ERROR_PASSWORD";
export const SUBMIT_ONPROGRESS = "SUBMIT_ONPROGRESS";
export const SUBMIT_DONE = "SUBMIT_DONE";